import React from "react";
import CodeManageItemList from "../fieldMng/shared/CodeManageItemList";
import DepartmentCommonEditor from "./subPages/DepartmentCommonEditor";
import CodeEditorPanel from "../fieldMng/shared/CodeEditorPanel";
import {useDepartmentManage} from "./useDepartmentManage";

function DepartmentManagePanel() {
    const {
        listData,
        selectedDepartment,
        setSelectedDepartment,
        setEditorDepartment,
        loading,
        handleCreateRoot,
        handleCreateChild,
        handleSaveEditor,
        handleUpdateChild,
        handleDelete,
    } = useDepartmentManage();

    if (loading) {
        return (
            <div className="code-manage-panel__body code-manage-scope">
                <div className="code-manage-panel__list code-manage-scope">
                    <div className="code-editor-empty">
                        <div className="code-editor-empty__icon">…</div>
                        <p className="code-editor-empty__title">불러오는 중</p>
                        <p className="code-editor-empty__desc">부서 목록을 가져오고 있습니다.</p>
                    </div>
                </div>
                <div className="code-manage-panel__editor code-manage-scope">
                    <CodeEditorPanel/>
                </div>
            </div>
        );
    }

    return (
        <div className="code-manage-panel__body code-manage-scope">
            <div className="code-manage-panel__list code-manage-scope">
                <CodeManageItemList
                    addLabel="부서"
                    addPlaceholder="새 부서명을 입력하세요"
                    createSectionLabel="루트 부서 추가"
                    items={listData}
                    selectedItemId={selectedDepartment?.id}
                    onSelect={setSelectedDepartment}
                    onCreateRoot={handleCreateRoot}
                    useAssetGroupTree
                    emptyMessage="등록된 부서가 없습니다. 아래에서 루트 부서를 추가하세요."
                />
            </div>
            <div className="code-manage-panel__editor code-manage-scope">
                {selectedDepartment ? (
                    <DepartmentCommonEditor
                        item={selectedDepartment}
                        setItem={setEditorDepartment}
                        onSave={handleSaveEditor}
                        onDelete={handleDelete}
                        onCreateChild={handleCreateChild}
                        onUpdateChild={handleUpdateChild}
                        onDeleteChild={handleDelete}
                    />
                ) : (
                    <div className="code-editor-empty">
                        <div className="code-editor-empty__icon">⌘</div>
                        <p className="code-editor-empty__title">부서를 선택하세요</p>
                        <p className="code-editor-empty__desc">
                            왼쪽 목록에서 부서를 선택하면 이곳에서 정보를 수정하고 하위 부서를 관리할 수 있습니다.
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
}

export default DepartmentManagePanel;
